import { Invoice, InvoiceStatus } from '../../services/invoice.service';

export const INVOICE_STATUS_META: Record<InvoiceStatus, { label: string; color: string }> = {
  draft: { label: 'Draft', color: 'text-gray-700 bg-gray-50 ring-gray-500/20' },
  issued: { label: 'Issued', color: 'text-blue-700 bg-blue-50 ring-blue-600/20' },
  overdue: { label: 'Overdue', color: 'text-red-700 bg-red-50 ring-red-600/20' },
  paid: { label: 'Paid', color: 'text-green-700 bg-green-50 ring-green-600/20' },
  cancelled: { label: 'Cancelled', color: 'text-yellow-800 bg-yellow-50 ring-yellow-600/20' },
};

// An issued invoice past its due date is overdue, whatever status was stored
export const getEffectiveStatus = (invoice: Pick<Invoice, 'status' | 'dueDate'>): InvoiceStatus => {
  if (invoice.status !== 'issued' && invoice.status !== 'overdue') return invoice.status;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return new Date(invoice.dueDate) < today ? 'overdue' : 'issued';
};

// Whole days an invoice is past its due date (0 when it is not)
export const getDaysOverdue = (invoice: Pick<Invoice, 'dueDate'>): number => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.max(0, Math.ceil((today.getTime() - new Date(invoice.dueDate).getTime()) / 86400000));
};

export const formatInvoiceDate = (value?: string | null) =>
  value
    ? new Date(value).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
    : '—';
